export default __webpack_public_path__ + "static/media/DOM-AUG2025.607381d6.png";